(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3Pager', {
            templateUrl: 'app/shared/pager/pager.component.html',
            bindings: {
                dataSource: '<source', // <== the "data-" gets striped
                pageSizes: '<'
            },
            controller: PagerComponent
        });

    var isArray = angular.isArray;

    PagerComponent.$inject = ['defaultPageSizes'];
    function PagerComponent(defaultPageSizes) {
        var ctrl = this;
        ctrl.$onInit = init;

        function init() {
            if (!isArray(ctrl.pageSizes) || !ctrl.pageSizes.length)
                ctrl.pageSizes = defaultPageSizes;
        }
    }
})();